import React, { createContext, useState, useEffect, useCallback, useRef } from 'react';
import socketService from './SocketService';
import { getStoredUser } from '../../../Config/ApiConfig';
import { useGlobal } from '../GlobalContext/GlobalContext';

export const SocketContext = createContext(null);

// Point to the backend server where Socket.IO is running
const serverUrl = "https://custom-answer.com";

export function SocketProvider({ children }) {
  const { token } = useGlobal();
  const [connectionState, setConnectionState] = useState({
    status: 'disconnected',
    error: null
  });
  const isInitialized = useRef(false);

  // Handler for connection state changes
  const handleConnectionChange = useCallback((state) => {
    console.log('Connection state change:', state);
    setConnectionState(prevState => {
      const newState = {
        ...prevState,
        status: state.status,
        error: state.status === 'error' ? state.message : null
      };
      console.log('New connection state:', newState);
      return newState;
    });
  }, [setConnectionState]);

  // Handler for socket errors
  const handleError = useCallback((error) => {
    setConnectionState(prevState => ({
      ...prevState,
      error: error.message || 'Unknown socket error'
    }));
  }, []);

  // Initialize socket service
  useEffect(() => {
    console.log('Initializing socket connection:', serverUrl);
    
    if (!token || !serverUrl) {
      console.log('Missing token or server URL, not connecting socket');
      return;
    }

    // Set up listeners for connection changes and errors
    const unsubscribeConnection = socketService.onConnect(handleConnectionChange);
    const unsubscribeError = socketService.onError(handleError);

    // Initialize and connect
    console.log('Initializing socket connection:', serverUrl);
    socketService.initialize(serverUrl, token.replace('Bearer ', ''));
    socketService.connect();

    return () => {
      console.log('Cleaning up socket connection');
      unsubscribeConnection();
      unsubscribeError();
      socketService.disconnect();
    };
  }, [handleConnectionChange, handleError, token]);

  // Update socket authentication when token changes
  useEffect(() => {
    if (token && isInitialized.current) {
      console.log('Token changed, updating socket auth');
      socketService.updateToken(token.replace('Bearer ', ''));
    }
    
    if (token) {
      isInitialized.current = true;
    }
  }, [token]);

  const contextValue = {
    socket: socketService,
    connectionState
  };

  return (
    <SocketContext.Provider value={contextValue}>
      {children}
    </SocketContext.Provider>
  );
}
